export const sanitizeURLForQueryParams = (pathname: string): string => {
  const lastSlashIndex = pathname.lastIndexOf("/");

  if (lastSlashIndex > -1 && lastSlashIndex === pathname.length - 1) {
    return pathname.substr(0, lastSlashIndex) + "?";
  }

  return `${pathname}?`;
};
